import { render } from "./batch-channel-inputs.vue?vue&type=template&id=3307c12d&lang=pug"
import script from "./batch-channel-inputs.vue?vue&type=script&lang=js"
export * from "./batch-channel-inputs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__